module.exports = __webpack_public_path__ + "static/img/Latitude East.9568245.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Latitude East.jpg
// module id = y/0n
// module chunks = 0